/**
 * Must evaluate before the `leaflet` module does - `maps.tsx` imports this
 * file first, and import order is evaluation order.
 *
 * Leaflet positions its panes with `translate3d`, which promotes them to
 * GPU compositor layers. Chromium then sorts those layers above ordinary
 * page content in ways that ignore paint order: LocationScreen's address
 * sheet was above the map by every CSS rule (later sibling, higher stacking
 * context, `elementFromPoint` agreed, clicks landed) and the tiles still
 * DREW on top of it. `L_DISABLE_3D` is Leaflet's own escape hatch: 2D
 * positioning, no layer promotion, normal paint order. Panning loses a
 * little GPU smoothness, which is cheap next to an invisible Save button.
 */

(globalThis as { L_DISABLE_3D?: boolean }).L_DISABLE_3D = true;

export {};
